<!--
 * @Author: jjchen
 * @Date: 2022-08-16 12:42:52
 * @LastEditors: jjchen
 * @LastEditTime: 2022-08-30 17:34:29
 * @Description: 
-->
<template>
  <div class="dropDown" v-show="visible">
    <van-loading :class="loadingItem" size="24px" vertical v-if="loading">加载中...</van-loading>
    <van-empty v-else-if="isEmpty" image="search" description="暂无数据" />
    <div v-else v-for="(item, index) in companyList" :key="index" @click="onClick(item)" :class="dropItem">
      <div>{{ item }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    companyList: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    flag: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropItem: '',
      loadingItem: '',
    }
  },
  watch: {
    flag: {
      immediate: true,
      handler(val) {
        if (val == 0) {
          this.dropItem = 'dropOne'
          this.loadingItem = 'loadingOne'
        } else {
          this.dropItem = 'dropTwo'
          this.loadingItem = 'loadingTwo'
        }
      },
    },
  },
  methods: {
    onClick(item) {
      this.$emit('checkName', item)
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="less" scoped>
.dropDown {
  //   width: 6.7rem;
  //   height: 3rem;
  overflow: auto;
  background-color: white;
  border-radius: 7px;
  box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.07);
  /deep/ .van-empty__image {
    width: 1.85rem;
    height: 1.85rem;
    display: flex;
    justify-content: center;
    margin-top: 0.45rem;
  }
  /deep/ .van-empty__description {
    margin-top: 0.05rem;
  }
  .loadingOne {
    margin-top: 1.8rem;
  }
  .loadingTwo {
    margin-top: 1.6rem;
  }
  .dropOne {
    padding-left: 0.3rem;
    height: 0.9rem;
    line-height: 0.9rem;
    div {
      width: 5.9rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0.3rem;
      width: 6.1rem;
      height: 0.01rem;
      background: #f5f5f5;
    }
  }
  .dropTwo {
    padding-left: 0.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    div {
      width: 5.9rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0.2rem;
      width: 6.1rem;
      height: 0.01rem;
      background: #f5f5f5;
    }
  }
}
</style>
